module.exports = __webpack_public_path__ + "img/IMG_9786_L_WoodMatted_MockedUp.c0f29ad2.jpg";